module.exports = __webpack_public_path__ + "assets/img/e42476bed1a5e9e0f36ab27999c09d2b.svg";